import { Injectable, inject } from "@angular/core";
import { Subject } from "rxjs";

import { IAppConfiguration } from "@logex/framework/lg-application";
import { AppSettings } from "@mrdm-self-service-frontend/shared/types";
import { MatomoConfiguration } from "@mrdm-self-service-frontend/shared/util-tracking";
import { AppLinks } from "libs/shared/types/src/lib/links";

@Injectable({
    providedIn: "root"
})
export class SharedConfigService {
    private _matomoConfiguration = inject(MatomoConfiguration);

    private _configuration: AppSettings | null = null;
    private _appConfigurationReady$ = new Subject<void>();
    private _appConfiguration: IAppConfiguration = {
        instance: "",
        environment: "",
        applicationInsightsInstrumentationKey: "",
        applicationInsightsExcludeDomains: [],
        userflowEnvironmentKey: "",
        userflowContentId: "",
        logoutUrl: "",
        switchHospital: true,
        switchHospitalUrl: "",
        switchMergedHospitals: true,
        testMachine: "",
        applicationRoot: "",
        ready: this._appConfigurationReady$.toPromise()
    };

    get applicationUrl(): string {
        return this._configuration?.api.applicationUrl || "";
    }

    get authorizationUrl(): string {
        return this._configuration?.api.authorizationUrl || "";
    }

    get myAccountUrl(): string {
        return this._configuration?.links?.myAccountLink || "";
    }

    get links(): AppLinks {
        return (
            this._configuration?.links || {
                supportLink: "",
                myAccountLink: ""
            }
        );
    }

    getConfiguration(): AppSettings | null {
        return this._configuration;
    }

    getAppConfiguration(): IAppConfiguration {
        return this._appConfiguration;
    }

    get isLocalOrTestEnv(): boolean {
        return (
            this._configuration?.environment === "test" ||
            this._configuration?.environment === "local"
        );
    }

    get isResourcesEnabled(): boolean {
        return this._configuration?.featureFlags?.resources === true;
    }

    get isCostCentersEnabled(): boolean {
        return this._configuration?.featureFlags?.costCenters === true;
    }

    public _setConfigation(config: AppSettings): void {
        this._configuration = config;
        this._matomoConfiguration.configure(config);

        this._appConfiguration = this._getAppConfiguration(config);
        this._appConfigurationReady$.next();
        this._appConfigurationReady$.complete();
    }

    private _getAppConfiguration(config: AppSettings): IAppConfiguration {
        return {
            ...this._appConfiguration,
            userflowEnvironmentKey: config?.userflow?.environmentKey,
            userflowContentId: config?.userflow?.contentId,
            environment: config.environment,
            instance: config.instance
        };
    }
}
